/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "eyflcynuffzbvgjcwhda"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV5ZmxjeW51ZmZ6YnZnamN3aGRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIxMjg5NDcsImV4cCI6MjA4NzcwNDk0N30.LufCWS7T5Yvr1xlX9NP5RibaaNPTzGv3A02_BImhBlw"